import { useMemo } from "react";

import clsx from "clsx";

import { BrandUsersGrid } from "./BrandUsersGrid";

export const BrandBrandUsers = ({ brand_id, className, ...props }) => {
  const classes = clsx("brand-brand-users", className);
  const filterParams = useMemo(() => {
    return {
      brand_id,
    };
  }, [brand_id]);
  return (
    <BrandUsersGrid
      filterParams={filterParams}
      className={classes}
      gridId="brand-brandusers"
    />
  );
};
